
;(function (jQuery) {

	jQuery(window).on("load", function() {

		/**
		 * Equalize heights of columns within 'services-image-section' section
		 */
		const equalizeColumnHeights = () => {
			// Select all columns within the parent container
			const columns = jQuery('.services-image-section .et_pb_column');

			// Reset any previously set heights
			columns.each(function() {
				jQuery(this).css('height', 'auto');
			});

			// Calculate the maximum height of all columns
			let maxHeight = 0;

			columns.each(function() {
				const columnHeight = jQuery(this).outerHeight();

				if (columnHeight > maxHeight) {
					maxHeight = columnHeight;
				}
			});

			// Set the maximum height on all columns
			columns.each(function() {
				jQuery(this).css('height', maxHeight + 'px');
			});
		};

		// Set tablet media query to prevent equal column height below this size
		const mediaQuery = window.matchMedia("(min-width: 981px)");

		/**
		 * Check media query and equalize column heights
		 */
		const handleMediaChange = () => {
			if (mediaQuery.matches) {
				equalizeColumnHeights();
			} else {
				// Reset heights
				const columns = jQuery('.services-image-section .et_pb_column');

				columns.each(function() {
					jQuery(this).css('height', 'auto');
				});
			}
		};

		// Initial check
		handleMediaChange();

		// Add listener for media query changes
		mediaQuery.addEventListener('change', handleMediaChange);

		// Re-run the function on window resize to handle responsive changes
		jQuery(window).on('resize', handleMediaChange);
	});

})(jQuery);



